import { Textarea } from "@mantine/core"
import { Button, Modal, Tooltip } from "@shopify/polaris"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const ProductAngle = ({ productAngle, onAngleChange, disabled }) => {
	const { t } = useTranslation()
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [_productAngle, _setProductAngle] = useState("")

	const onProductAngleChange = (e) => {
		_setProductAngle(e.target.value)
	}

	const onSave = () => {
		onAngleChange(_productAngle)
		setModalIsOpen(false)
	}

	useEffect(() => {
		if (modalIsOpen && productAngle) {
			_setProductAngle(productAngle)
		}
	}, [modalIsOpen])

	return (
		<>
			<div
				style={{
					background: "#dcdcdc",
					color: "#444",
					borderRadius: "0.3rem",
					display: "flex",
					gap: "0.2rem",
					fontSize: "0.75rem",
					cursor: "pointer",
					width: "fit-content",
				}}
				onClick={() => {
					if (!disabled) {
						setModalIsOpen(true)
					}
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						padding: "0.1rem 0.3rem",
						paddingRight: "0.1rem",
						borderRadius: "0.3rem 0rem 0rem 0.3rem",
					}}
				>
					<svg width={"0.9rem"} height={"0.9rem"} viewBox="0 0 16 16">
						<path
							fill="currentColor"
							d="M14 1.5a.5.5 0 0 0-1 0V2h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0V3h.5a.5.5 0 0 0 0-1H14zm-8.61.63a.2.2 0 0 1 .06-.104C5.474 2.002 5.493 2 5.5 2s.026.002.052.026a.2.2 0 0 1 .059.104a4.2 4.2 0 0 0 1.135 2.124A4.2 4.2 0 0 0 8.87 5.39a.2.2 0 0 1 .104.059c.024.025.026.044.026.051s-.002.026-.026.052a.2.2 0 0 1-.104.058a4.2 4.2 0 0 0-2.124 1.137A4.2 4.2 0 0 0 5.611 8.87a.2.2 0 0 1-.059.104c-.026.024-.044.026-.051.026c-.008 0-.026-.002-.052-.026a.2.2 0 0 1-.058-.104a4.2 4.2 0 0 0-1.137-2.124A4.2 4.2 0 0 0 2.13 5.61a.2.2 0 0 1-.103-.059C2.003 5.526 2 5.507 2 5.501c0-.008.002-.026.026-.052a.2.2 0 0 1 .104-.059a4.2 4.2 0 0 0 2.123-1.136A4.2 4.2 0 0 0 5.391 2.13M5.5 1c-.576 0-.99.453-1.088.926a3.2 3.2 0 0 1-.865 1.62a3.2 3.2 0 0 1-1.62.865c-.473.098-.927.513-.926 1.091c.001.576.454.989.926 1.087c.426.088 1.067.31 1.62.864s.776 1.195.865 1.621c.098.473.512.926 1.089.926s.99-.454 1.089-.927c.088-.425.31-1.066.864-1.62a3.2 3.2 0 0 1 1.62-.864C9.547 6.491 10 6.077 10 5.5s-.453-.99-.926-1.09a3.2 3.2 0 0 1-1.62-.863a3.2 3.2 0 0 1-.864-1.62C6.49 1.452 6.078 1 5.5 1m5.44 4a2.1 2.1 0 0 1 0 1h.56A1.5 1.5 0 0 1 13 7.5v4a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 6 11.5v-.56a2.1 2.1 0 0 1-1 0v.56A2.5 2.5 0 0 0 7.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 11.5 5zM8 8.5a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1H10a.5.5 0 0 0 0-1zm-6 2a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0V14h-.5a.5.5 0 0 1 0-1H2v-.5a.5.5 0 0 1 .5-.5"
						></path>
					</svg>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.2rem",
						padding: "0.1rem 0.3rem",
						paddingLeft: "0rem",
					}}
				>
					<Tooltip
						content={
							<div
								style={{
									padding: "0.5rem",
									maxWidth: "22rem",
									fontSize: "0.85rem",
									lineHeight: "1.2",
								}}
							>
								<p>
									{t(
										"ai.choose_a_focus_to_guide_your_copywriting",
									)}
								</p>
								<p style={{ marginTop: "0.5rem" }}>
									{t("ai.for_example_you_could_talk_about")}
								</p>
							</div>
						}
					>
						<span
							style={{
								textDecoration: "underline dotted #444",
								cursor: "help",
							}}
						>
							{t("ai.product_angle_optional")}
						</span>{" "}
						<b>{productAngle ? t("ai.custom") : t("ai.default")}</b>
					</Tooltip>
					<svg width={"0.8rem"} height={"0.8rem"} viewBox="0 0 24 24">
						<path
							fill="currentColor"
							d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1q-.15.15-.15.36M20.71 5.63l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83l3.75 3.75l1.83-1.83a.996.996 0 0 0 0-1.41"
						></path>
					</svg>
				</div>
			</div>

			<Modal
				title={t("ai.choose_a_product_angle_optional")}
				open={modalIsOpen}
				onClose={() => {
					setModalIsOpen(false)
					_setProductAngle("")
				}}
			>
				<div style={{ padding: "1rem" }}>
					<Textarea
						label={t("ai.product_angle")}
						value={productAngle}
						onChange={onProductAngleChange}
						placeholder={t("ai.write_a_specific_product_angle")}
						radius="md"
					/>

					<div
						style={{
							marginTop: "1rem",
							marginLeft: "auto",
							width: "fit-content",
						}}
					>
						<Button onClick={onSave}>
							{t("common.save_changes")}
						</Button>
					</div>
				</div>
			</Modal>
		</>
	)
}
